import React from 'react'
import {
    Form,

} from "@redriver/cinnamon";

const NonPropagatingDropdown = (props) => {
    return (
        <Form.Dropdown {...props} onKeyDown={(e) => e.stopPropagation()} />
    )
}
export default NonPropagatingDropdown
